const tours = {
  tour: "旅行", // translated
  tours: "ツアー", // translated
  addOn: "アドオン", // translated
  addOns: "アドオン", // translated
  availableEscapes: "利用可能なエスケープ", // translated
  availableExperiences: "利用可能な体験", // translated
  getRequest: "リクエストの取得", // translated
  sendRequest: "リクエストの送信", // translated
  selectRoom: "部屋を選択してください", // translated
};



export default tours;
